module.exports = __webpack_public_path__ + "afec7ec2fde5a60f27c17c67f2d87ad5.png";